import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { Settings } from 'lucide-react';
import { PaigeLogo } from '@paige/ui';
import { Profile } from '../../shell/Profile';
import { Bell } from '../../shell/Bell';
import { AdminMark } from '../../shell/AdminMark';

/**
 * The bar: the logo; for staff the admin area; settings (one way in, the gear: scanners and devices
 * are a page inside it and a row of the profile menu; Dustin, 2026-10-07); the bell; the person.
 */
export function JobsBar({ tenantId }: { tenantId: string }): ReactNode {
  return (
    <header className="paige-jobs__bar">
      <PaigeLogo height={24} />
      <span className="paige-jobs__marks">
        <AdminMark />
        <Link
          to="/t/$tenant/settings"
          params={{ tenant: tenantId }}
          className="company-mark"
          aria-label="Settings"
          title="Settings: people, API keys, security"
        >
          <Settings size={17} aria-hidden="true" />
        </Link>
        <Bell tenantId={tenantId} />
        <Profile tenantId={tenantId} />
      </span>
    </header>
  );
}
